module.exports = __webpack_public_path__ + "img/05.3f963b71.png";